import {StyleSheet} from 'aphrodite/no-important'

export default StyleSheet.create({
  container: {
    // margin: '140px 0 0',
    width: '100%',
    padding: '40px 0',
    background: '#fff',
    boxShadow: '0 1px 2px rgba(0, 0, 0, 0.10)',
    flexDirection: 'row',
    borderRadius: '3px',
  },
  containerPadding: {
    minWidth: '20px',
    flex: '0 1 40px',
  },
  contentContainer: {
    width: '100%',
  },
})
